const eventName = 'openImageModalEvent';
const dispatch = (url, tag) => {
	const newEvent = new CustomEvent(eventName, { detail: { url, tag } });
	window.dispatchEvent(newEvent);
}

export {eventName, dispatch};